import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.93662 4C1.86706 4 1 4.77194 1 5.72419V18.2763C1 19.2285 1.86705 20.0005 2.93662 20.0005H21.0634C22.133 20.0005 23 19.2285 23 18.2763V5.72419C23 4.77194 22.133 4 21.0634 4H2.93662ZM13.0845 8.41392C13.0845 7.95684 13.5007 7.58631 14.0141 7.58631H18.0422C18.5556 7.58631 18.9718 7.95684 18.9718 8.41392V12.0002C18.9718 12.4573 18.5556 12.8278 18.0422 12.8278H14.0141C13.5007 12.8278 13.0845 12.4573 13.0845 12.0002V8.41392ZM5.95772 14.7588C5.44433 14.7588 5.02814 15.1293 5.02814 15.5864C5.02814 16.0435 5.44433 16.414 5.95772 16.414H18.0422C18.5556 16.414 18.9718 16.0435 18.9718 15.5864C18.9718 15.1293 18.5556 14.7588 18.0422 14.7588H5.95772ZM5.0282 8.41393C5.0282 7.95685 5.44439 7.58632 5.95778 7.58632H8.97891C9.4923 7.58632 9.90849 7.95685 9.90849 8.41393C9.90849 8.871 9.4923 9.24154 8.97891 9.24154H5.95778C5.44439 9.24154 5.0282 8.871 5.0282 8.41393ZM5.95772 11.1725C5.44433 11.1725 5.02814 11.543 5.02814 12.0001C5.02814 12.4572 5.44433 12.8277 5.95772 12.8277H8.97885C9.49224 12.8277 9.90843 12.4572 9.90843 12.0001C9.90843 11.543 9.49224 11.1725 8.97885 11.1725H5.95772Z"
      fill="currentColor"
    />
  </svg>
);
